<template>
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="19.5"
      cy="19.5"
      r="19.5"
      fill="var(--systemError)"
    />
    <path
      d="M24.2619 11.5923C25.2336 10.4536 26.6835 9.88428 28.0576 10.8028C29.2494 11.5999 29.7049 13.437 28.8395 14.6441C27.0403 17.172 24.5352 18.918 22.2122 20.8993C19.6312 23.1008 15.7338 26.7219 14.6938 27.8303C13.6538 28.9386 10.6844 29.6446 9.75829 28.5894C8.07604 26.1602 10.4592 23.6044 11.8611 22.6302C13.4629 20.9069 16.3821 18.4549 18.1433 16.9215C20.1702 15.1527 22.5007 13.6496 24.2619 11.5923Z"
      fill="white"
    />
    <path
      d="M11.8599 14.699C10.7212 13.7274 10.1519 12.2774 11.0704 10.9034C11.8675 9.71153 13.7046 9.25607 14.9116 10.1215C17.4396 11.9206 19.1856 14.4258 21.1669 16.7487C23.3684 19.3298 26.9895 23.2271 28.0978 24.2671C29.2062 25.3071 29.9122 28.2765 28.857 29.2026C26.4277 30.8849 23.872 28.5017 22.8977 27.0998C21.1745 25.4981 18.7225 22.5789 17.189 20.8177C15.4203 18.7908 13.9172 16.4602 11.8599 14.699Z"
      fill="white"
    />
  </svg>
</template>